module.exports = __webpack_public_path__ + "24_pvis.jpg?2346781be2b05bed44005fabc86b61e5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/24_pvis.jpg
// module id = 210
// module chunks = 0